import MasterManagement from './views/MasterManagement.vue';
import Masters from './Masters.vue';
import { productRoutes } from './views/product/routes';
import { saleZoneRoutes } from './views/saleZone/routes';

export const mastersRoutes = [
  {
    path: 'masters',
    component: Masters,
    children: [
      ...productRoutes,
      ...saleZoneRoutes,
      { path: '', component: MasterManagement, name: 'masters' }
    ]
  }
];
